import { createFileRoute, redirect } from '@tanstack/react-router';

// Sprint Settings Panel IA — Parte 4. /equipo se movió a /settings/team
// dentro del nuevo panel de Configuración. Este archivo queda como
// redirect para no romper bookmarks ni links internos legacy. La UI
// completa vive en routes/_app/settings/team.tsx (mismo componente,
// solo cambió la envoltura).
export const Route = createFileRoute('/_app/equipo/')({
  beforeLoad: () => {
    throw redirect({ to: '/settings/team' });
  },
});
